<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="tabs">
				<div class="top_input2">
					<el-select v-model="checkType" placeholder="请选择">
						<el-option label="车牌号" value="1"> </el-option>
					</el-select>
				</div>
				<div class="top_input3">
					<el-select v-model="checkTypeValue" filterable placeholder="请选择" clearable>
						<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
							:value="item.index">
							<!-- <span style="float: left">{{ item.value }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.index }}
						</span> -->
						</el-option>
					</el-select>
					<!-- <el-input type="text" placeholder="请输入" v-model="searchWord"></el-input> -->
				</div>
				<div class="top_input2">
					<el-select v-model="ddtjType" placeholder="请选择">
						<el-option label="选择月" value="1"> </el-option>
						<el-option label="选择周" value="2"> </el-option>
					</el-select>
				</div>
				<div v-if="ddtjType=='1'"
					style="display: flex;width: 350px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;">
					<el-date-picker style="width: 250px; height: 35px" v-model="monthStr" type="month" placeholder="选择月"
						:clearable="false" @change="getMonthChange">
					</el-date-picker>
				</div>
				<div v-if="ddtjType=='2'"
					style="display: flex;width: 400px; height: 35px;padding: 0 5px;align-items: center;justify-content: flex-start;">
					<el-date-picker style="width: 330px; height: 35px" v-model="wdate" type="week"
						:format="wstartTime +' 至 ' +wendTime +'   (第' +wweek +'周)'" placeholder="请选择周"
						@change="weekChange">
					</el-date-picker>
				</div>
				<div v-if="monthStart && monthEnd">
					月份开始日期: {{ monthStart }}<br>
					月份结束日期: {{ monthEnd }}
				</div>
				<div class="search_btn" @click="getData">查询</div>
				<div class="search_btn" @click="exportClick()" v-if="permissionItem.export">导出</div>
			</div>
			<div class="close_button">
				<el-popover :visible="popoverVisible" @show="showPopover" placement="bottom" trigger="click"
					:width="200">
					<div style="max-height: 300px; overflow-y: auto;">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
							@change="handleCheckAllChange">全选</el-checkbox>
						<div style="margin: 10px 0;"></div>
						<el-checkbox-group v-model="checkedColumns" @change="handleCheckedColumnsChange"
							style="display: flex;flex-direction: column;">
							<el-checkbox v-for="column in columns" :label="column.lable"
								:key="column.lable">{{column.lable}}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div style="text-align: right; margin: 0">
						<el-button size="small" text @click="popoverVisible = false">取消</el-button>
						<el-button size="small" type="primary" @click="confirmPopover">
							确认
						</el-button>
					</div>
					<template #reference>
						<!-- <el-button @click="visible = true">列设置</el-button> -->
						<div @click="popoverVisible = true">
							<i class="iconfont icon-shezhi"> 列设置</i>
						</div>
					</template>
				</el-popover>
			</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" ref="tableRef" :key="tableKey"
					highlight-current-row @current-change="handleCurrentChange">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column fixed prop="vehNo" label="车牌号" width="120"
						v-if="showColumn('车牌号')"></el-table-column>
					<el-table-column prop="odrCount" label="单量" width="120" v-if="showColumn('单量')"></el-table-column>
					<el-table-column prop="freightMilage" label="运费里程(KM)" width="120"
						v-if="showColumn('运费里程(KM)')"></el-table-column>
					<el-table-column prop="freightMoney" label="运费收入(元)" width="120"
						v-if="showColumn('运费收入(元)')"></el-table-column>
					<el-table-column prop="sumIncome" label="总收入(元)" width="120"
						v-if="showColumn('总收入(元)')"></el-table-column>
					<el-table-column prop="sumCost" label="总成本(元)" width="120"
						v-if="showColumn('总收入(元)')"></el-table-column>
					<el-table-column prop="sumMoney" label="利润(元)" width="120"
						v-if="showColumn('利润(元)')"></el-table-column>
					<el-table-column prop="loadsWeightSum" label="总装货吨位" width="120"
						v-if="showColumn('总装货吨位')"></el-table-column>
					<el-table-column prop="unlsWeightSum" label="总卸货吨位" width="120"
						v-if="showColumn('总卸货吨位')"></el-table-column>
					<el-table-column prop="lossWeightSum" label="途损吨位" width="120"
						v-if="showColumn('途损吨位')"></el-table-column>
					<el-table-column prop="heaMilage" label="重车总里程(KM)" width="130"
						v-if="showColumn('重车总里程(KM)')"></el-table-column>
					<el-table-column prop="empMilage" label="空车总里程(KM)" width="130"
						v-if="showColumn('空车总里程(KM)')"></el-table-column>
					<el-table-column prop="sumMilage" label="总里程(KM)" width="120"
						v-if="showColumn('总里程(KM)')"></el-table-column>
					<el-table-column prop="gpsSumMileage" label="GPS参考里程" width="140" v-if="showColumn('GPS参考里程')">
						<template #default="scope">
							<span>{{formatMileage(scope.row.gpsSumMileage)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="empDuration" label="空车总时长" width="120" v-if="showColumn('空车总时长')">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.empDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="heaDuration" label="重车总时长" width="120" v-if="showColumn('重车总时长')">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.heaDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="sumDuration" label="总时长" width="120" v-if="showColumn('总时长')">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.sumDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="oilOdometer" label="燃料里程(KM)" width="120"
						v-if="showColumn('燃料里程(KM)')"></el-table-column>
					<el-table-column prop="oilCount" label="燃料量(KG)" width="120"
						v-if="showColumn('燃料量(KG)')"></el-table-column>
					<el-table-column prop="oilMoney" label="燃料金额(元)" width="120"
						v-if="showColumn('燃料金额(元)')"></el-table-column>
					<el-table-column prop="oilCons" label="百公里能耗" width="120"
						v-if="showColumn('百公里能耗')"></el-table-column>
					<!-- <el-table-column prop="roleCreName" label="空闲空车里程" width="120"></el-table-column>
					<el-table-column prop="roleCreName" label="空闲空车时长" width="120"></el-table-column>
					<el-table-column prop="roleCreName" label="运费总金额" width="120"></el-table-column> -->
					<el-table-column prop="freewayCost" label="高速费(元)" width="120"
						v-if="showColumn('高速费(元)')"></el-table-column>
					<el-table-column prop="tollCost" label="路桥费(元)" width="120"
						v-if="showColumn('路桥费(元)')"></el-table-column>
					<el-table-column prop="fuelCost" label="燃料费(元)" width="120"
						v-if="showColumn('燃料费(元)')"></el-table-column>
					<el-table-column prop="maintenanceCost" label="维修费(元)" width="120"
						v-if="showColumn('维修费(元)')"></el-table-column>
					<el-table-column prop="parkingCost" label="停车费(元)" width="120"
						v-if="showColumn('停车费(元)')"></el-table-column>
					<el-table-column prop="insuSharCost" label="保险分摊费(元)" width="120"
						v-if="showColumn('保险分摊费(元)')"></el-table-column>
					<el-table-column prop="safetyCost" label="安全费(元)" width="120"
						v-if="showColumn('安全费(元)')"></el-table-column>
					<el-table-column prop="depreciationCost" label="折旧费(元)" width="120"
						v-if="showColumn('折旧费(元)')"></el-table-column>
					<el-table-column prop="mdriveSalary" label="驾驶员薪资(元)" width="120"
						v-if="showColumn('驾驶员薪资(元)')"></el-table-column>
					<el-table-column prop="yayunSalary" label="押运员薪资(元)" width="120"
						v-if="showColumn('押运员薪资(元)')"></el-table-column>
					<el-table-column prop="otherCost" label="其他费用(元)" width="120"
						v-if="showColumn('其他费用(元)')"></el-table-column>
					<el-table-column prop="monthly" label="所属月份" width="260"
						v-if="showColumn('所属月份')"></el-table-column>
					<!-- <el-table-column label="操作" fixed="right" width="100px">
						<template #default="scope">
							<span class="default_color pointer m-right10"
								v-on:click="detail(scope.row.roleId)">详情</span>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import {
		formatMileage,
	} from "@/libs/mapUtils";
	import dayjs from 'dayjs';
	import zhCn from "element-plus/es/locale/lang/zh-cn";

	dayjs.en.weekStart = 1; //el-date-picker组件展示：调整周一为起始日
	export default defineComponent({
		name: "vehLedgerManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const popoverVisible = ref(false);
			const checkAll = ref(true);
			const tableKey = ref(0) // 关键：用于强制重新渲染
			// 选择展示的字段数组默认的
			const columns = ref([{
					lable: '车牌号',
					show: true
				},
				{
					lable: '单量',
					show: true
				},
				{
					lable: '运费里程(KM)',
					show: true
				},
				{
					lable: '运费收入(元)',
					show: true
				},
				{
					lable: '总收入(元)',
					show: true
				},
				{
					lable: '总成本(元)',
					show: true
				},
				{
					lable: '利润(元)',
					show: true
				},
				{
					lable: '总装货吨位',
					show: true
				},
				{
					lable: '总卸货吨位',
					show: true
				},
				{
					lable: '途损吨位',
					show: true
				},
				{
					lable: '重车总里程(KM)',
					show: true
				},
				{
					lable: '空车总里程(KM)',
					show: true
				},
				{
					lable: '总里程(KM)',
					show: true
				},
				{
					lable: 'GPS参考里程',
					show: true
				},
				{
					lable: '空车总时长',
					show: true
				},
				{
					lable: '重车总时长',
					show: true
				},
				{
					lable: '总时长',
					show: true
				},
				{
					lable: '燃料里程(KM)',
					show: true
				},
				{
					lable: '燃料量(KG)',
					show: true
				},
				{
					lable: '燃料金额(元)',
					show: true
				},
				{
					lable: '百公里能耗',
					show: true
				},
				{
					lable: '高速费(元)',
					show: true
				},
				{
					lable: '路桥费(元)',
					show: true
				},
				{
					lable: '燃料费(元)',
					show: true
				},
				{
					lable: '维修费(元)',
					show: true
				},
				{
					lable: '停车费(元)',
					show: true
				},
				{
					lable: '保险分摊费(元)',
					show: true
				},
				{
					lable: '安全费(元)',
					show: true
				},
				{
					lable: '折旧费(元)',
					show: true
				},
				{
					lable: '驾驶员薪资(元)',
					show: true
				},
				{
					lable: '押运员薪资(元)',
					show: true
				},
				{
					lable: '其他费用(元)',
					show: true
				},
				{
					lable: '所属月份',
					show: true
				}
			]);

			const checkedColumns = ref([]) //选中的数据
			const isIndeterminate = ref(false)
			//表格实例
			const tableRef = ref(null)
			const currentRow = ref()

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				checkType: "1",
				monthStr: "",
				year: "",
				vehHeadNo: "",
				checkTypeValue: "",
				checkTypeList: [],
				ddtjType: "1",

				permissionItem: {
					list: false,
					export: false,
				},

				wdate: '',
				wstartTime: dayjs().format('YYYY-MM-DD'),
				wendTime: dayjs().format('YYYY-MM-DD'),
				wweek: 0,
				monthStart: null, // 月份开始日期
				monthEnd: null // 月份结束日期
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "vehLedgerManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "vehLedgerManage:export") {
						data.permissionItem.export = true;
					}
				});
				// 强制表格重新渲染
				tableKey.value++

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;

					getData();
					checkTypeChange("1");
					gettableColumn();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};

				var d = new Date();
				var year = d.getFullYear();
				var month = d.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				data.year = year.toString();
				console.log(data.year);
				data.monthStr = year + "-" + month;
			});

			//处理展示数据
			const weekChange = (val) => {
				const date = new Date(val);
				const y = date.getFullYear();
				const m = date.getMonth();

				const d = date.getDate();
				const week = date.getDay();
				const start = new Date(y, m, d - week + 1);
				const end = new Date(y, m, d - week + 7);

				data.wstartTime = getCurrentTime(start, 0);
				data.wendTime = getCurrentTime(end, 0);
				data.wweek = getWeekNumber(end);
			};

			const getWeekNumber = (date) => {
				const startOfYear = new Date(date.getFullYear(), 0, 1);
				const dateTimeStamp = date.getTime();
				const yearStartTimeStamp = startOfYear.getTime();
				const diff = dateTimeStamp - yearStartTimeStamp;
				const daysSinceStartOfYear = diff / (1000 * 60 * 60 * 24);
				const weeks = Math.floor(daysSinceStartOfYear / 7);
				return weeks + 1;
			};

			const getCurrentTime = (data, num) => {
				let date = new Date(data);
				var Y = date.getFullYear();
				var M = date.getMonth() + 1;
				var D = date.getDate() + num;
				if (M < 10) {
					M = "0" + M;
				}
				if (D < 10) {
					D = "0" + D;
				}
				return Y + "-" + M + "-" + D
			};

			const handleDateChange = (value) => {
				if (value) {
					const year = value.getFullYear(); // 获取年份
					const month = value.getMonth() + 1; // 获取月份，月份是从0开始的，所以要加1
					const firstDay = new Date(year, month - 1, 1); // 月份的第一天
					const lastDay = new Date(year, month, 0); // 月份的最后一天，月份参数加0表示获取上个月的最后一天，也就是当前月的最后一天
					data.monthStart = firstDay.toISOString().split('T')[0]; // 格式化日期字符串
					data.monthEnd = lastDay.toISOString().split('T')[0]; // 格式化日期字符串
				} else {
					data.monthStart = null;
					data.monthEnd = null;
				}
			};


			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询单车台账权限！");
					return;
				}

				if (data.checkType == "1") {
					data.vehHeadNo = data.checkTypeValue;
				}

				if (data.ddtjType == '1') {
					//按月查询
					let params = {
						page: data.page,
						limit: data.pageSize,
						date: data.monthStr + '-01',
						vehNo: data.vehHeadNo, //车牌号 
					};
					const r = await proxy.$http.get(apiObj.transLedgerByVehicle, params);
					console.log(r);
					if (r.code === 0 || r.respCode == "0000") {
						data.tableData = r.odrList;
						data.totalCount = r.odrCount;
					}
				} else if (data.ddtjType == '2') {
					//按时间段查询
					let params = {
						page: data.page,
						limit: data.pageSize,
						startDate: data.wstartTime,
						endDate: data.wendTime,
						vehNo: data.vehHeadNo, //车牌号 
					};
					const r = await proxy.$http.get(apiObj.transLedgerByVehicleToDate, params);
					console.log(r);
					if (r.code === 0 || r.respCode == "0000") {
						data.tableData = r.odrList;
						data.totalCount = r.odrCount;
					}
				}

			};

			//获取显示列设置
			const gettableColumn = async () => {

				let params = {
					type: 'vehLedgerManage',
				};
				const r = await proxy.$http.get(apiObj.tableColumnGet, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					if (r.data !== null && r.data !== undefined && r.data != "") {
						const array = JSON.parse(r.data.utbcColumns);
						let selectedItem = null;

						columns.value.forEach(item1 => {
							selectedItem = array.find(item => item.lable === item1.lable);
							if (selectedItem) {
								item1.show = selectedItem.show;
							}
							// if (array.some(item2 => item2.lable === item1.lable)) {
							// 	item1.show = item2.show;
							//columns.value.push(item1); // 添加到array2中
							//}
						});

						// columns.value.forEach(item => {
						// 	if (checkedColumns.value.some((el) => el == item.lable)) {
						// 		item.show = true;
						// 	} else {
						// 		item.show = false;
						// 	}
						// })
					}
				}
			};

			//更新显示列设置
			const updatetableColumn = async () => {

				let params = {
					utbcType: 'vehLedgerManage',
					utbcColumns: JSON.stringify(columns.value),
				};
				const r = await proxy.$http.post(apiObj.tableColumnUpdate, params);
				console.log(r);
				if (r.code === 0 || r.respCode == "0000") {
					proxy.$message.success(r.msg || r.respMsg);
				}
			};

			//导出数据
			const exportClick = async () => {
				if (!data.permissionItem.export) {
					proxy.$message.error("没有单车账导出权限！");
					return;
				}

				if (data.checkType == "1") {
					data.vehHeadNo = data.checkTypeValue;
				}

				if (data.ddtjType == '1') {
					//按月查询

					let params = {
						date: data.monthStr + '-01',
						vehNo: data.vehHeadNo, //车牌号 
					};

					const r = await proxy.$http.downloadPostFormData(apiObj.exportTransLedgerByVehicle,
						params,
						"单车台账数据");
					console.log(r);

				} else if (data.ddtjType == '2') {
					//按时间段查询
					let params = {
						startDate: data.wstartTime,
						endDate: data.wendTime,
						vehNo: data.vehHeadNo, //车牌号 
					};

					const r = await proxy.$http.downloadPostFormData(apiObj
						.exportTransLedgerByVehicleToDate,
						params,
						"单车台账数据");
					console.log(r);
				}
			};

			const checkTypeChange = async (value) => {
				data.checkTypeValue = "";
				if (value == "1") {
					//获取车辆
					let params = {
						searchWord: "",
						page: 1,
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.vehicleList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.vehHeadNo,
								index: el.vehHeadNo,
							});
						});
					}
				}
			};



			//菜单删除
			const del = (roleId) => {
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							roleId: roleId,
						};
						const r = await proxy.$http.post(apiObj.roleDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const getMonthChange = (ev) => {
				console.log(ev);
				var date = new Date(ev);
				var y = date.getFullYear();
				var month = date.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				data.monthStr = y + "-" + month;
				//this.getList();
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			// 点击弹出框的“全选”按钮
			const handleCheckAllChange = (val) => {
				let columnsValueList = [];
				columns.value.map(item => columnsValueList.push(item.lable));
				checkedColumns.value = val ? columnsValueList : [];
				isIndeterminate.value = false;
			};
			// 点击弹出框的选择展示菜单的复选框
			const handleCheckedColumnsChange = (value) => {
				let checkedCount = value.length;
				checkAll.value = checkedCount === columns.value.length;
				isIndeterminate.value = checkedCount > 0 && checkedCount < columns.value.length;
			};

			// 弹出框打开时触发
			const showPopover = () => {
				// 选中目前已展示的字段值
				checkedColumns.value = [];
				columns.value.map((item) => {
					if (item.show) {
						checkedColumns.value.push(item.lable);
					}
				});
				// 如果目前展示的是全部字段，则需要勾选上“全选”按钮
				if (columns.value.length == checkedColumns.value.length) {
					checkAll.value = true;
					isIndeterminate.value = false;
				} else {
					isIndeterminate.value = true;
				}

				// 重新渲染表格
				nextTick(() => {
					tableRef.value.doLayout();
				})
			};

			// 表格列是否显示的方法
			const showColumn = (currentColumn) => {
				const column = columns.value.find((item) => item.lable === currentColumn);
				if (column) {
					return column.show;
				} else {
					//console.error(`Column with label "${currentColumn}" not found.`);
					//return undefined; // 或者您可以选择抛出一个错误
					return false;
				}
			};
			// 点击弹出框的“确定”按钮
			const confirmPopover = () => {
				//选择不能没有,需要可放开注释
				// if(checkedColumns.value.length == 0) {
				//   ElMessage.error('请选择需要展示的表格字段')
				//     return;
				// }
				// 根据选择结果，遍历修改列是否展示的属性值
				columns.value.forEach(item => {
					if (checkedColumns.value.some((el) => el == item.lable)) {
						item.show = true;
					} else {
						item.show = false;
					}
				})
				popoverVisible.value = false;
				// 重新渲染表格
				nextTick(() => {
					tableRef.value.doLayout();
					updatetableColumn(); //更新保存

				})
			};

			const handleCurrentChange = (val) => {
				currentRow.value = val
			};

			return {
				...toRefs(data),
				getData,
				del,
				getMonthChange,
				exportClick,
				timeDeltaCount,
				formatMileage,
				weekChange,
				handleDateChange,
				columns,
				tableRef,
				isIndeterminate,
				checkedColumns,
				checkAll,
				popoverVisible,
				handleCheckAllChange,
				handleCheckedColumnsChange,
				showPopover,
				showColumn,
				confirmPopover,
				tableKey,
				handleCurrentChange,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.tabs {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	.close_button {
		width: 100px;
		height: 100%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>